/**
 * @module users
 */
import { createReducer } from '@reduxjs/toolkit';
import { userActions } from '~/behaviors/actions/user.actions';
import { taskActions } from '~/behaviors/actions/task.actions';
import { taskTemplateActions } from '~/behaviors/actions/task_template.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

/**
 * Iterate over each element of `action.payload.users` and merge each with any
 * existing entity with the same ID in the state (or create new one if none exist).
 */
const mergeUsers = (state, action) => {
  const users = action?.payload?.entities?.users || [];

  Object.values(users).forEach((user) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[user.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[user.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...user,
    };
  });
};

/**
 * Replace all existing users with latest users list from the server.
 */
const replaceUsers = (state, action) => {
  return action?.payload?.entities?.users || defaultState;
};

const assignUsersToRole = (state, action) => {
  if (action?.payload?.entities?.roles) {
    const role = Object.values(action?.payload?.entities?.roles)[0];
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    const userIds = role.userIds || [];
    userIds.forEach((userId) => {
      state[userId] = {
        ...state[userId],
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        userRoleId: role.id,
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        permissions: role.permissions,
      };
    });
  }
};

const unassignUsersToRole = (state, action) => {
  const userIds = action?.payload?.userIds || [];
  userIds.forEach((userId) => {
    state[userId] = {
      ...state[userId],
      userRoleId: null,
    };
  });
};

const users = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(userActions.fetchUsers.fulfilled, replaceUsers);
  builder.addCase(userActions.fetchUsersWithPermissions.fulfilled, mergeUsers);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(taskActions.fetchTaskList.fulfilled, mergeUsers);
  builder.addCase(taskActions.fetchTask.fulfilled, mergeUsers);
  builder.addCase(taskActions.createTask.fulfilled, mergeUsers);
  builder.addCase(taskTemplateActions.fetchTaskTemplateList.fulfilled, mergeUsers);
  builder.addCase(taskTemplateActions.fetchTaskTemplate.fulfilled, mergeUsers);
  builder.addCase(userActions.updateRole.fulfilled, assignUsersToRole);
  builder.addCase(userActions.modifyUserPermissions.fulfilled, (state, action) => {
    unassignUsersToRole(state, action);
    mergeUsers(state, action);
  });
  builder.addCase(userActions.createUsers.fulfilled, mergeUsers);
});

export default users;
